import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components/index.js';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';

import { useAsync, useUser } from '../../../../hooks/index.js';
import CustomText from 'containers/Common/customComponents/CustomText.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import CustomTextarea from 'containers/Common/customComponents/CustomTextarea.tsx';
import { commonMsg } from 'utils/globalUtil.tsx';
import _ from 'lodash';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  title: string;
  ptwDSeq: number;
  onActionCallback: any;
}

const PermitIssueTypeModal = (props: IProps) => {
  const { callAsync, showAlarm, closeAlarm } = useAsync();
  const [data, setData] = useState<any>({});
  const user = useUser();

  const modalClose = () => {
    props.setIsModalOpen(false);
  };

  const handleChange = (e: any) => {
    setData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  useEffect(() => {
    if (!props.isModalOpen) return;
    setData({
      cancellerId: user.userInfo?.userId,
      ptwDSeq: props.ptwDSeq
    });
  }, [props.isModalOpen, props.ptwDSeq]);

  //ok
  const save = () => {
    let formData = _.cloneDeep(data);
    commonMsg.confirm(
      showAlarm,
      closeAlarm,
      'Confirm',
      'Would you like to cancel this Permit?',
      () => {
        ptwApi.cancel(formData).then(async (r) => {
          if (!r.isSuccess) {
            commonMsg.alert(showAlarm, closeAlarm, 'Error', 'Error', null);
            return;
          }
          commonMsg.alert(showAlarm, closeAlarm, 'Success', 'Canceled successfully', () => {
            props.onActionCallback();
            modalClose();
          });
        });
      }
    );
  };

  const onReset = () => {
    setData((prev: any) => ({
      ...prev,
      cancelComment: ''
    }));
  };

  return (
    <BasicModalV2 open={props.isModalOpen} onClose={() => props.setIsModalOpen(false)}>
      <CustomModalHeader title={props.title} modalClose={modalClose} />
      <div
        className={'custom-modal-body permit-cancel-modal'}
        style={{ width: '500px', height: '100%' }}
      >
        <div className={'contents-box'}>
          <div className={'header-title'}>* Name</div>
          <div style={{ width: '100%' }}>
            <CustomText
              name={'cancelName'}
              className={'form'}
              onChange={handleChange}
              value={data?.cancelName}
              readOnly={true}
              defaultValue={user.userInfo?.fullName}
            />
          </div>

          <div className={'cancel-header'}>
            <span className={'header-title'}>* Comment</span>
            <button
              className="header-btn"
              onClick={() => {
                onReset();
              }}
            >
              Reset
            </button>
          </div>
          <div style={{ width: '100%', height: '100%' }}>
            <CustomTextarea
              name={'cancelComment'}
              className={'form'}
              onChange={handleChange}
              value={data?.cancelComment}
              isReload={true}
            />
          </div>
          <div className={'button-box'}>
            <TextButton
              className={'cancel-style'}
              variant="outlined"
              style={{ height: '40px' }}
              onClick={() => {
                modalClose();
              }}
            >
              Close
            </TextButton>

            <TextButton
              variant="contained"
              style={{ height: '40px' }}
              onClick={() => {
                save();
              }}
            >
              OK
            </TextButton>
          </div>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default PermitIssueTypeModal;
